module.exports = {
      id: "back-icon-usage",
      viewBox: "0 0 7.828 12.828",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#back-icon",
      toString: function () {
        return this.url;
      }
    }